// extracted by mini-css-extract-plugin
module.exports = {"closed-menu":"_3tiw_F","opened-menu":"_1BHnzc"};